import React from "react";
import { Collapse, Form } from "react-bootstrap";
import TermsAndConditions from "./TermsAndConditions";

function Step3Review({
  currentStep,
  handleGoToStep,
  agreed,
  setAgreed,
  handlePurchase,
  handleNextStep,
}) {
  return (
    <div className="card rounded-0 border-0 checkoutCard  mb-3">
      <div className="card-header border-0 d-flex justify-content-between">
        <h5
          className={`text-capitalize mb-0 fw-bold ${
            currentStep === 3 ? "" : "text-grey"
          } ${currentStep > 3 ? "text-primary-color" : ""} `}
        >
          3. Review & Purchase
        </h5>
        {currentStep > 3 ? (
          <button
            className="border-0 bg-0 text-grey"
            onClick={() => handleGoToStep(3)}
          >
            Edit
          </button>
        ) : null}
      </div>
      <Collapse in={currentStep === 3}>
        <div>
          <div className="card-body">
            <TermsAndConditions />
            <Form.Check
              type="checkbox"
              id="agree"
              label="I agree to the terms and conditions"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <button
              className="continuePaymentBtn w-100 bg-primary-color border-0 p-1 text-white w-100 mt-3"
              onClick={() => handleNextStep(4)}
              disabled={!agreed}
            >
              Next
            </button>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default Step3Review;
